import {
  Box,
  Button,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import axiosInstance from "../../helpers/axiosInstance";
import { useHistory } from "react-router-dom";
import AdminHeader from "./AdminHeader";

const AdminMailbox = () => {
  const toast = useToast();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const emailsPerPage = 8;

  const fetchMailboxEmails = async () => {
    try {
      const response = await axiosInstance.get("/userform/mailbox");
      setEmails(response.data.data.emails);
      setIsLoading(false);
    } catch (error) {
      toast({
        title: "Error fetching user data.",
        description: error.response?.data?.message || "An error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMailboxEmails();
  }, []);

  // Calculate pagination
  const indexOfLastEmail = currentPage * emailsPerPage;
  const indexOfFirstEmail = indexOfLastEmail - emailsPerPage;
  const currentEmails = emails.slice(indexOfFirstEmail, indexOfLastEmail);

  const totalPages = Math.ceil(emails.length / emailsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <Box h="100vh" bg="white">
      <AdminHeader title="Info Mailbox" />

      {isLoading ? (
        <Spinner m={4} size="lg" />
      ) : (
        /* Table Section with Scroll */
        <Box p={4} h="90vh" overflowY="auto">
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>From</Th>
                <Th>Subject</Th>
                <Th>Date</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentEmails.map((email, index) => (
                <Tr key={index}>
                  <Td>{email.from}</Td>
                  <Td>{email.subject}</Td>
                  <Td>{email.date}</Td>
                  <Td>
                    <Button size="sm" onClick={() => setSelectedEmail(email)}>
                      View
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>

          {/* Pagination Controls */}
          <Box display="flex" justifyContent="space-between" mt={4}>
            <Button
              size="sm"
              onClick={handlePreviousPage}
              isDisabled={currentPage === 1}
            >
              Previous
            </Button>
            <Text>
              Page {currentPage} of {totalPages}
            </Text>
            <Button
              size="sm"
              onClick={handleNextPage}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Box>

          {selectedEmail && (
            <Box mt={4} p={4} borderWidth="1px" borderRadius="lg">
              <h2>
                <strong>Subject:</strong> {selectedEmail.subject}
              </h2>
              <p>
                <strong>From:</strong> {selectedEmail.from}
              </p>
              <p>
                <strong>Date:</strong> {selectedEmail.date}
              </p>
              <Box
                mt={2}
                p={2}
                borderWidth="1px"
                borderRadius="md"
                bg="gray.100"
              >
                <pre>{selectedEmail.body}</pre>
              </Box>
              <Button mt={2} onClick={() => setSelectedEmail(null)}>
                Close
              </Button>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AdminMailbox;
